import { render, staticRenderFns } from "./QrOrderEmail.vue?vue&type=template&id=d188355c&scoped=true&"
import script from "./QrOrderEmail.vue?vue&type=script&lang=js&"
export * from "./QrOrderEmail.vue?vue&type=script&lang=js&"
import style0 from "./QrOrderEmail.vue?vue&type=style&index=0&id=d188355c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d188355c",
  null
  
)

export default component.exports